module.exports = __webpack_public_path__ + "img/vivobook16copilot.c5f83268.jpg";